import { extendTheme } from '@chakra-ui/react'

const config = {
	initialColorMode: 'light',
	useSystemColorMode: false,
}

const theme = extendTheme({
	config,
	focusBorderColor: '#a84b32',
	fonts: {
		body: 'Inter, Arial, sans-serif',
		heading: 'Inter, Arial, sans-serif',
		date: 'Inter, Arial, sans-serif',
	},
	colors: {
		paper: '#fdfdfc',
		ink: '#111111',
		muted: '#737373',
		accent: '#a84b32',
	},
	styles: {
		global: {
			'html': { scrollBehavior: 'smooth' },
			'body': { background: '#fdfdfc', color: '#111111' },
			'::selection': { background: '#e8e8e6', color: '#111111' },
		},
	},
})

export default theme
